// TODUE V2 — „Som platiteľ DPH" flag (perzistencia, settings key/value).
//
// Zrkadlí vzor businessTypes.js (getActiveBusinessType/setActiveBusinessType):
// rovnaká settings tabuľka, rovnaký get/set/fallback vzor. Default = FALSE
// (neplatiteľ) — väčšina malých živnostníkov DPH priznanie nepodáva.
//
// Tento súbor LEN ukladá a exponuje stav. Zapojenie do termínov/pravidiel
// (taxDeadlineNext/guardStatus/pack) príde v ďalšom balíku — kontrakt pre neho
// je export getVatPayer().
//
// UI sa po zmene prepočíta automaticky: putSetting ide cez adapter → db.onChange
// → cache invalidateStore('settings') (v2/cache.js). Žiadny manuálny notify.
//
// initV2() na začiatku get/set: V2 engine je lazy singleton — otvorí sa až v
// initV2() (alebo prvom write). SettingsV2 stránka (na rozdiel od DashboardV2)
// initV2 sama NEVOLÁ, takže vatStatus musí byť self-sufficient — inak reálny
// OPFS zápis hodí „engine nie je otvorený" a prepínač sa ticho vráti späť
// (jsdom testy to nechytia — majú engine vždy otvorený). initV2 je idempotentný.
import { db, putSetting, initV2 } from './db';

export const VAT_PAYER_KEY = 'vat_payer';

// Uložený stav alebo default false. Chýbajúce/poškodené → false (nikdy crash).
// settings.value je JSON stĺpec (adapter) → boolean sa vráti natívne.
export async function getVatPayer() {
  try {
    await initV2();
    const row = await db.settings.get(VAT_PAYER_KEY);
    return row?.value === true;
  } catch (e) {
    console.warn('[v2] getVatPayer failed, fallback false (neplatiteľ)', e);
    return false;
  }
}

// Uloží čistý boolean (truthy/falsy → true/false). Vracia uloženú hodnotu.
export async function setVatPayer(isPayer) {
  await initV2();
  const value = !!isPayer;
  await putSetting({ key: VAT_PAYER_KEY, value });
  return value;
}
